import NavItemSkeleton from './help/NavItemSkeleton';

// STYLES
import { Container } from './styles';

const NavigationSkeleton = () => {
  return (
    <Container>
      <NavItemSkeleton />
      <NavItemSkeleton />
      <NavItemSkeleton />
      <NavItemSkeleton />
      <NavItemSkeleton />
      <NavItemSkeleton />
    </Container>
  );
};

export default NavigationSkeleton;
